import React from 'react';

import { createDashboardPageClassName } from './dashboardPageStyles';

type TProps = {
  text: string;
  onClick(): void;
};

export const DashboardPageButton: React.FC<TProps> = ({ text, onClick }) => (
  <button className={createDashboardPageClassName('button')} onClick={onClick}>
    {text}
  </button>
);
